import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  { id: "d9d93ffd-5443-4797-a350-4a5dd8ef1e6a", content: "Distance", options: {} },
  { id: "9737adcd-45a4-4cab-957d-a95ef6036dbd", content: "Localizability", options: {} },
  { id: "ef958787-43a9-43fc-81b2-20fb455e8358", content: "Loudness", options: {} },
  { id: "2fb305d6-d3a5-429e-8d3f-efa3fe575462", content: "Distortion", options: {} },
  { id: "b3e0cb6a-61b4-45cc-9bbb-7a2e047c51a5", content: "Clarity", options: {} },
  { id: "84cfe003-7452-496f-b3aa-404802b375d0", content: "Naturalness", options: {} },
  { id: "0d335788-916e-43d5-9287-bfdc39003747", content: "Presence", options: {} },
  { id: "d1866978-e9a9-46b1-a3e4-044a08a24f37", content: "Level of reverberation", options: {} },
];

const groups = [
  { id: "fc7fa163-5507-4fb7-8dba-2677fbbdd60c", content: "quieter – louder", options: {} },
  { id: "b54b5b30-e542-49da-956b-1cc1b0c81c12", content: "less pronounced – more pronounced", options: {} },
  { id: "d4b879d6-b408-486a-922c-f8d883ad6155", content: "less intense – more intense", options: {} },
  { id: "980c3063-44b6-441a-a212-b30a7e4b8594", content: "less – more", options: {} },
  { id: "a78bd651-a1bd-4a99-bbeb-9b7e97d4c463", content: "closer – more distant", options: {} },
  { id: "f826005b-7ff8-4f3f-b43a-eac1b2d72235", content: "more difficult – easier", options: {} },
  { id: "7b3dc5a3-e09c-4f34-8bff-41df73d37e17", content: "lower – higher", options: {} },
];

export const task: Task = {
  id: "b1c8077d-e972-4c23-9648-759a0bf34b75",
  solutionType: "group",
  type: "connectWithLine",
  options: {
    shuffle: true,
    multipleConnection: true,
  },
  items,
  groups,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "group",
  data: [
    { groupId: "fc7fa163-5507-4fb7-8dba-2677fbbdd60c", itemsId: ["ef958787-43a9-43fc-81b2-20fb455e8358"] },
    { groupId: "b54b5b30-e542-49da-956b-1cc1b0c81c12", itemsId: ["b3e0cb6a-61b4-45cc-9bbb-7a2e047c51a5"] },
    { groupId: "d4b879d6-b408-486a-922c-f8d883ad6155", itemsId: ["2fb305d6-d3a5-429e-8d3f-efa3fe575462"] },
    { groupId: "980c3063-44b6-441a-a212-b30a7e4b8594", itemsId: ["d1866978-e9a9-46b1-a3e4-044a08a24f37"] },
    { groupId: "a78bd651-a1bd-4a99-bbeb-9b7e97d4c463", itemsId: ["d9d93ffd-5443-4797-a350-4a5dd8ef1e6a"] },
    { groupId: "f826005b-7ff8-4f3f-b43a-eac1b2d72235", itemsId: ["9737adcd-45a4-4cab-957d-a95ef6036dbd"] },
    {
      groupId: "7b3dc5a3-e09c-4f34-8bff-41df73d37e17",
      itemsId: ["84cfe003-7452-496f-b3aa-404802b375d0", "0d335788-916e-43d5-9287-bfdc39003747"],
    },
  ],
};
